// Which consent regime applies to this visitor (2026-09-17, Veronika's call):
//   'eu'    → Europe: cookie banner shown; PostHog counts cookieless until "Accept"
//   'other' → everyone else: analytics run from the first page, no banner
// EA is a US company, so GDPR/ePrivacy reach us through visitors located in Europe.
// Anything uncertain (no country header, request failure, localhost) resolves to 'eu'.
export type VisitorRegion = 'eu' | 'other'

// EEA (EU 27 + IS, LI, NO), UK, Switzerland, and the rest of geographic Europe.
export const EUROPE_COUNTRIES = new Set([
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE',
  'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
  'IS', 'LI', 'NO',
  'GB', 'CH',
  'AD', 'AL', 'AX', 'BA', 'BY', 'FO', 'GG', 'GI', 'IM', 'JE', 'MC', 'MD', 'ME', 'MK',
  'RS', 'RU', 'SJ', 'SM', 'TR', 'UA', 'VA', 'XK',
])

export function regionForCountry(country: string | null | undefined): VisitorRegion {
  if (!country) return 'eu'
  return EUROPE_COUNTRIES.has(country.toUpperCase()) ? 'eu' : 'other'
}

const PRODUCTION_HOSTS = /(^|\.)electrification-academy\.com$/

let regionPromise: Promise<VisitorRegion> | null = null

/** Resolved once per page load; the banner and PostHog share the same answer. */
export function getVisitorRegion(): Promise<VisitorRegion> {
  if (regionPromise) return regionPromise
  // Staging/preview only: ?geo=eu|other forces a region so both paths can be checked
  const forced = new URLSearchParams(window.location.search).get('geo')
  if (!PRODUCTION_HOSTS.test(window.location.hostname) && (forced === 'eu' || forced === 'other')) {
    regionPromise = Promise.resolve(forced)
    return regionPromise
  }
  regionPromise = fetch('/api/geo', { cache: 'no-store' })
    .then(res => (res.ok ? res.json() : null))
    .then((data: { region?: VisitorRegion } | null) => (data?.region === 'other' ? 'other' : 'eu'))
    .catch((): VisitorRegion => 'eu')
  return regionPromise
}
